import axios from 'axios.js'
import * as Types from './ActionTypes';
import { openPopup } from './PopupAlertActions';

export const getTableListing = (title, rowsPerPage, page, sort, field, filters) => (dispatch) => {
    dispatch({ type: Types.GET_TABLE_LISTING_PENDING })
    axios
        .get(`admin/listing/${title}`, { params: { rowsPerPage, page, sort, field, filters, field } })
        .then((res) => {
            dispatch({
                type: Types.GET_TABLE_LISTING_SUCCESS,
                payload: res.data,
            })
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, title, null, error.status))
            dispatch({
                type: Types.GET_TABLE_LISTING_FAILED,
                payload: null,
            })
        })
}

export const getItemDetails = (title, id) => (dispatch) => {
    dispatch({ type: Types.GET_ITEM_DETAILS_PENDING })
    axios
        .get(`admin/details/${title}/${id}`)
        .then((res) => {
            dispatch({
                type: Types.GET_ITEM_DETAILS_SUCCESS,
                payload: res.data,
            })
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, title, null, error.status))
            dispatch({
                type: Types.GET_ITEM_DETAILS_FAILED,
                payload: null,
            })
        })
}

export const updateTableListing = (tableListing) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_TABLE_LISTING,
        payload: tableListing,
    })
}

export const updateItemDetails = (itemDetails) => (dispatch) => {
    dispatch({
        type: Types.UPDATE_ITEM_DETAILS,
        payload: itemDetails,
    })
}

export const upsertItemDetails = (title, id, params) => (dispatch) => {
    axios
        .post(`admin/upsert/${title}/${id}`, { ...params })
        .then((res) => {
            console.log(' upsertItemDetails data', res.data)
            if (res.data.redirect) {
                dispatch(openPopup(true, res.data.message, 'success', null, title, id, res.data.status, res.data.redirect))
            } else {
                dispatch(openPopup(true, res.data.message, 'success', null, title, id))
            }
            dispatch({
                type: Types.UPDATE_ITEM_DETAILS_SUCCESS,
                payload: res.data.data,
            })
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, title, id, error.status))
        })
}

export const upsertFileDetails = (title, id, formdata) => (dispatch) => {
    axios
        .post(`admin/upsert/${title}/${id}`, formdata)
        .then((res) => {
            console.log(' upsertItemDetails data', res.data)
            if (res.data.redirect) {
                dispatch(openPopup(true, res.data.message, 'success', null, title, id, res.data.status, res.data.redirect))
            } else {
                dispatch(openPopup(true, res.data.message, 'success', null, title, id))
            }
            dispatch({
                type: Types.UPDATE_ITEM_DETAILS_SUCCESS,
                payload: res.data.data,
            })
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, title, id, error.status))
        })
}

export const deleteItemDetails = (title, id) => (dispatch) => {
    axios
        .post(`admin/delete/${title}/${id}`)
        .then((res) => {
            dispatch(openPopup(true, res.data.message, 'success', null, title, id))
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, title, id, error.status))
        })
}

export const importItemDetails = (title, formdata) => (dispatch) => {
    console.log('importItemDetails data', formdata)
    axios
        .post(`admin/import/${title}`, formdata,)
        .then((res) => {
            console.log('importItemDetails data', res.data)
            if (res.data.redirect) {
                dispatch(openPopup(true, res.data.message, 'success', null, title, 0, res.data.status, res.data.redirect))
            } else {
                dispatch(openPopup(true, res.data.message, 'success', null, title, 0))
            }
            dispatch({
                type: Types.IMPORT_ITEM_DETAILS_SUCCESS,
                payload: res.data.data,
            })
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, title, 0, error.status))
        })
}

export const resendVerify = (email) => (dispatch) => {
    axios
        .get(`admin/email/resend/${email}`)
        .then((res) => {
            dispatch(openPopup(true, res.data.message, 'success'))
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, null, null, error.status))
        })
}

export const resetPassword = (email) => (dispatch) => {
    axios
        .post('admin/forgotpassword/send', { email: email })
        .then((res) => {
            dispatch(openPopup(true, res.data.message, 'success'))
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, null, null, error.status))
        })
}

export const downloadPDF = (id, type) => (dispatch) => {
    axios
        .get(`admin/downloadCustomerApplicationsLink/${id}/${type}`)
        .then((res) => {
            window.open(res.data, '_blank');
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, null, null, error.status))
        })
}

export const downloadExcel = (period) => (dispatch) => {
    axios
        .get(`admin/listing/ms_user/export?period=${period}`)
        .then((res) => {
            window.open(res.data, '_blank');
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, null, null, error.status))
        })
}

export const emailPDF = (id) => (dispatch) => {
    axios
        .get(`admin/emailCustomerApplications/${id}`)
        .then((res) => {
            dispatch(openPopup(true, res.data.message, 'success', null, null, null, res.data.status, `/details/customer_lead_applications/${id}`))
        })
        .catch(error => {
            dispatch(openPopup(true, error.message, 'error', null, null, null, error.status))
        })
} 